import React from "react";
import styles from "./Cards.module.css";
import Button from "./Button";

const Cards = ({ title, desc, img, website }) => {
  return (
    <div className={styles.cardCtn}>
      <div className={styles.cardInfo}>
        <div>
          <h3 className={styles.cardTitle}>{title}</h3>
          <p className={styles.cardDesc}>{desc}</p>
        </div>
        <Button website={website} />
      </div>
      <div className={styles.imgCtn}>
        <img src={img} alt={title} className={styles.img} />
      </div>
    </div>
  );
};

export default Cards;
